import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chat",
  "use": "icon-chat-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chat\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 12L3 6L5 6L5 12L7 12L7 14L9 14L9 12L15 12L15 6L17 6L17 12L15 12L15 14L9 14L9 16L7 16L7 14L5 14L5 12L3 12ZM5 6L5 4L15 4L15 6L5 6Z\" fill=\"#A6A6A6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol